import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const Slide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
  padding-top: 30px;
  width: 100%;
`;

export const Title = styled(Text.H3)``;

export const ContentArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  position: relative;
  width: 100%;
`;

export const ScrollableArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 60px;
  width: 100%;
`;

export const Fade = styled.div`
  background: linear-gradient(
    to bottom,
    ${colours.shade[0]}00 0%,
    ${colours.shade[0]} 100%
  );
  bottom: 0;
  height: 60px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
`;

export const Buttons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
